import ParaphraserPillar from 'src/mics/components/paraphraserPillar/ParaphraserPillar';
import withQuillLayout from 'src/_common/hoc/QuillLayout';

export default withQuillLayout({
  children: ParaphraserPillar,
});
